import React, { useContext } from 'react'
import { AppContext } from '../../../context/AppContext';
import { motion } from "framer-motion";
const NotificationDetails = () => {
    const { sidebar, setSidebar, Dark, setDark } = useContext(AppContext);
    const aninations = {
    initial: { opacity: 0, x: 400 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
  }; 
  return (
        <motion.div className={sidebar ? "taskMain " : "cx-active taskMain"} id="cx-main"variants={aninations}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.1 }}>
            <div id='cx-wrapper'>
                <div className="main-master-wrapper information-card">
                    <div className="Heading">
                        <p>Trip Name here...</p>
                    </div>
                    <div className="information-contain row">
                        <div className="information-discriptiopn col-lg-3 col-md-4 col-sm-6 mb-4">
                            <p className="discription-heading">Vehicle</p>
                            <p className="discription-contain">100</p>
                        </div>
                        <div className="information-discriptiopn col-lg-3 col-md-4 col-sm-6 mb-4">
                            <p className="discription-heading">Driver</p>
                            <p className="discription-contain">john@gmail.com</p>
                        </div>
                        <div className="information-discriptiopn col-lg-12">
                            <p className="discription-heading">Message</p>
                            <p className="discription-contain">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    )
}

export default NotificationDetails